import axios from 'axios';

import { PropertyConvoSummaryDto } from '../dtos/property-convo-summary.dto.interface';

class PropertyConvoSummaryService {
  async getConvoSummaries(propertyId: string): Promise<PropertyConvoSummaryDto[]> {
    const response = await axios.get<PropertyConvoSummaryDto[]>(`property-feedback/${propertyId}/convo-summaries`);

    return response.data;
  }
}

export default new PropertyConvoSummaryService();
